exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p-fieldset  {\r\n    width: 100%\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/shared/layout/body-fieldset/panel-generico.component.css
// module id = ../../../../../src/app/area-restrita/shared/layout/body-fieldset/panel-generico.component.css
// module chunks = main